import { render } from "./SaleProductChart.vue?vue&type=template&id=01991ef3"
import script from "./SaleProductChart.vue?vue&type=script&lang=js"
export * from "./SaleProductChart.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Proj\\Apps\\tabarok_management\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__